import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClearPushTokenMutationVariables = Types.Exact<{
  deviceId: Types.Scalars['String']['input'];
  userId: Types.Scalars['ID']['input'];
}>;


export type ClearPushTokenMutation = { __typename?: 'Mutation', clearPushToken: boolean };


export const ClearPushTokenDocument = gql`
    mutation ClearPushToken($deviceId: String!, $userId: ID!) {
  clearPushToken(data: {deviceId: $deviceId, userId: $userId})
}
    `;
export type ClearPushTokenMutationFn = Apollo.MutationFunction<ClearPushTokenMutation, ClearPushTokenMutationVariables>;

/**
 * __useClearPushTokenMutation__
 *
 * To run a mutation, you first call `useClearPushTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearPushTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearPushTokenMutation, { data, loading, error }] = useClearPushTokenMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useClearPushTokenMutation(baseOptions?: Apollo.MutationHookOptions<ClearPushTokenMutation, ClearPushTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearPushTokenMutation, ClearPushTokenMutationVariables>(ClearPushTokenDocument, options);
      }
export type ClearPushTokenMutationHookResult = ReturnType<typeof useClearPushTokenMutation>;
export type ClearPushTokenMutationResult = Apollo.MutationResult<ClearPushTokenMutation>;
export type ClearPushTokenMutationOptions = Apollo.BaseMutationOptions<ClearPushTokenMutation, ClearPushTokenMutationVariables>;